import { updateDeveloperReversement, updateEnvironment } from "../../../developer/services/developerApi";
import toast from "react-hot-toast";
import { Skeleton, Segmented, Tooltip, Tag, Modal, Spin } from "antd";
import { ExclamationCircleOutlined, InfoCircleOutlined, WarningOutlined} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { configureRetention } from "../services/developerApi";
const BusinessAction = ({
  developer,
  onRefresh,
  setDeveloper,
  setSelectedDeveloper,
  setModalMode,
  setIsManageModalOpen
}) => {
    const [isRetentionModalOpen, setIsRetentionModalOpen] = useState(false);
const handleConfigureRetention = async () => {
  const payload = {
    percentage: Number(retentionData.percentage || 0),
    durationDays: Number(retentionData.durationDays || 0),
    enabled: Boolean(retentionData.enabled),
  };
  try {
    await configureRetention(developer.id, payload);

    toast.success("Configuration du hold mise à jour avec succès ✅");
    setIsRetentionModalOpen(false);
    onRefresh?.();

  } catch (error) {
    console.error(error);
    toast.error("Le pourcentage doit être entre 0 et 1 (ex: 0.1 = 10%)");
  }
};
const [retentionData, setRetentionData] = useState({
  businessId: developer?.id,
  percentage: "",
  durationDays: "",
  enabled: true,
});
    const handleEnvironmentChange = async (developer, value) => {
  const mode = value.toUpperCase();
  const updateMode = async () => {
    try {
      await updateEnvironment({
        businessId: developer.id,
        mode: mode
      });

      // ✅ Mettre à jour le state local instantanément
      setDeveloper((prev) => ({
        ...prev,
        environmentMod: mode
      }));

      toast.success(`Mode changé en ${mode}`);

    } catch (error) {
      console.error(error);
      toast.error("Le business doit être actif avant de passer en mode LIVE.");
    }
  };

  if (mode === "LIVE") {
    Modal.confirm({
      title: "Passer en mode LIVE",
      icon: <ExclamationCircleOutlined />,
      content:
        "Vous êtes sur le point de passer ce business en mode LIVE. Les transactions seront réelles.",
      okText: "Passer en LIVE",
      okType: "danger",
      cancelText: "Annuler",
      onOk: updateMode
    });
  } else {
    updateMode();
  }
};
const [isEnabled, setIsEnabled] = useState(
  Boolean(developer?.payoutEnabled)
);

useEffect(() => {
  setIsEnabled(Boolean(developer?.payoutEnabled));
}, [developer]);

const handleToggleReversement = async (value) => {
  const enabled = Boolean(value);

  try {
    await updateDeveloperReversement({
      developerAccountId: developer.id,
      enable: enabled, // ✅ API attend enable
    });

    setIsEnabled(enabled);

    setDeveloper((prev) => ({
      ...prev,
      payoutEnabled: enabled, // ✅ FRONT utilise payoutEnabled
    }));

    toast.success(
      enabled
        ? "Reversement activé ✅"
        : "Reversement désactivé ❌"
    );

    onRefresh?.();

  } catch (err) {
    console.error(err);
    toast.error("Erreur lors de la mise à jour");
  }
};
    return(
  <div className="action-card">
    <div className="action-header">⚙️ Gestion du business</div>

    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: "15px",
        justifyContent: "space-between",
      }}
    >
       <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
    <span
      style={{
        fontSize: "13px",
        fontWeight: 600,
        color: "#667085",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
      }}
    >
      Environnement
    </span>
     <div style={{ display: "flex", alignItems: "center", gap: "10px" }}> 
              {developer.environmentMod === "SANDBOX" && (
                <Tag color="#fa8c16"
                style={{ padding: "3px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",}}
                  >
                Sandbox
                </Tag>
              )}

              {developer.environmentMod === "LIVE" && (
                <Tag color="#349C32"
                style={{ padding: "3px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",}}
                  >
                  Production
                </Tag>
              )}
              <Segmented
                value={developer.environmentMod}
                options={[
                  {
                    label: (
                      <span style={{ color: "#fa8c16", fontWeight: 500 }}>
                        Sandbox
                      </span>
                    ),
                    value: "SANDBOX",
                  },
                  {
                    label: (
                      <span style={{ color: "#349C32", fontWeight: 500 }}>
                        Live
                      </span>
                    ),
                    value: "Live",
                  },
                ]}
                onChange={(value) => handleEnvironmentChange(developer, value)}
              />
              <Tooltip title="Sandbox = environnement de test | Live = production">
                <InfoCircleOutlined
                  style={{
                    color: "#396AFC",
                    fontSize: "18px",
                    cursor: "pointer"
                  }}
                />
              </Tooltip>
            </div>
    </div>
      {/* 🔹 REVERSEMENT */}
       <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
    <span
      style={{
        fontSize: "13px",
        fontWeight: 600,
        color: "#667085",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
      }}
    >
      Reversement
    </span>
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <Tag color={isEnabled ? "#349C32" : "#D41C1C"} 
        style={{ padding: "3px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",}}>
          {isEnabled ? "Reversement ON" : "Reversement OFF"}
        </Tag>
        <Segmented
          value={isEnabled}
          options={[
            { label: "OFF", value: false },
            { label: "ON", value: true },
          ]}
          onChange={(value) => handleToggleReversement(Boolean(value))}/>

        <Tooltip title="Activer / désactiver reversement">
          <InfoCircleOutlined style={{ color: "#396AFC" }} />
        </Tooltip>
      </div>
    </div>
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>

    <span
      style={{
        fontSize: "13px",
        fontWeight: 600,
        color: "#667085",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
      }}
    >
      Retenue
    </span>
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <span
          style={{
            backgroundColor: developer.holdEnabled ? "#349C32" : "#D41C1C",
            color: developer.holdEnabled ? "#ffffff" : "#ffffff",
            padding: "3px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px"
          }}
        >
          {developer.holdEnabled ? "Retenu activé" : "Retenu désactivée"}
        </span>

        <Segmented
  value={developer?.holdEnabled}
  options={[
    { label: "OFF", value: false },
    { label: "ON", value: true },
  ]}
  onChange={async (value) => {

    // ✅ OFF => désactivation directe sans modal
    if (value === false) {
      try {
        await configureRetention(developer.id, {
          percentage: 0,
          durationDays: 0,
          enabled: false,
        });

        setDeveloper((prev) => ({
          ...prev,
          holdEnabled: false,
        }));

        toast.success("Retenue désactivée ❌");

        onRefresh?.();

      } catch (error) {
        console.error(error);
        toast.error("Erreur lors de la désactivation");
      }

      return;
    }

    // ✅ ON => ouvrir modal pour configuration
    setRetentionData({
      businessId: developer.id,
      percentage: "",
      durationDays: "",
      enabled: true,
    });

    setIsRetentionModalOpen(true);
  }}
/>
      </div>
    </div>
    </div>
 <Modal
  title="Configuration des retenues"
  open={isRetentionModalOpen}
  onCancel={() => setIsRetentionModalOpen(false)}
  onOk={handleConfigureRetention}
>
  <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
    
    {/* POURCENTAGE */}
    <div>
      <label>Pourcentage (%)</label>

      <input
        type="number"
        placeholder="Ex: 10"
        value={retentionData.percentage}
        onChange={(e) =>
        setRetentionData((prev) => ({
            ...prev,
            percentage: e.target.value === "" ? "" : Number(e.target.value),
        }))
        }
        style={{
          width: "100%",
          padding: "8px",
          borderRadius: "6px",
          border: "1px solid #d9d9d9",
        }}
      />
    </div>

    {/* DURATION */}
    <div>
      <label>Durée (jours)</label>

      <input
        type="number"
        placeholder="Ex: 7"
        value={retentionData.durationDays}
      onChange={(e) =>
        setRetentionData((prev) => ({
            ...prev,
            durationDays: e.target.value === "" ? "" : Number(e.target.value),
        }))
        }
        style={{
          width: "100%",
          padding: "8px",
          borderRadius: "6px",
          border: "1px solid #d9d9d9",
        }}
      />
    </div>

    {/* ENABLED */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <span>Retenue activée</span>

      <Segmented
        value={retentionData.enabled}
        options={[
          { label: "OFF", value: false },
          { label: "ON", value: true },
        ]}
        onChange={(value) =>
          setRetentionData((prev) => ({
            ...prev,
            enabled: value,
          }))
        }
      />
    </div>
  </div>
</Modal>
  </div>

        );

};
export default BusinessAction